'use strict';

DoohApps
.directive('ngClipboard', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        scope: {
            clipClick: '&',
            clipClickFail:'&'
        },
        link: function (scope, elem, attrs, ctrl) {
            var clipboard = new Clipboard(elem[0], {
                text: function (trigger) {
                    return trigger.getAttribute('text');
                }
            });
            clipboard.on('success', function (e) {
                scope.clipClick();
            });
            clipboard.on('error', function (e) {
                scope.clipClickFail();
            });
        }
    };
}]);